// src/components/PaymentLinkTable.js
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const PaymentLinkTable = ({ links, onDeleteClick, onEditClick }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false); // 3秒後にメッセージを非表示
    }, 2000); // 3000ミリ秒（3秒）後にメッセージを消す
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="payment links table">
          <TableHead>
            <TableRow>
              <TableCell>アプリ名</TableCell>
              <TableCell>リンク</TableCell>
              <TableCell>更新日</TableCell>
              <TableCell>有効期限</TableCell>
              <TableCell>削除</TableCell>
              <TableCell>編集</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {links.map((link) => (
              <TableRow key={link.id}>
                <TableCell>{link.app_name}</TableCell>
                <TableCell>
                  <CopyToClipboard text={link.link} onCopy={handleCopy}>
                    {/* <Button variant="text" style={{ textTransform: 'none' }}>{link.link}</Button> */}
                    <IconButton color="primary" title="コピー">
                      <ContentCopyIcon />
                    </IconButton>
                  </CopyToClipboard>
                </TableCell>

                <TableCell>
                  {new Date(link.updated_at).toLocaleString()}
                </TableCell>
                <TableCell>
                  {new Date(link.expires_at).toLocaleString()}
                </TableCell>
                <TableCell>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    onClick={() => onDeleteClick(link.id)}
                    title="削除"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <IconButton
                    variant="contained"
                    color="primary"
                    onClick={() => onEditClick(link)}
                    title="編集"
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* コピーされたら表示するSnackbar */}
      <Snackbar
        open={isCopied}
        autoHideDuration={2000} // 3秒後に自動的に消える
        onClose={() => setIsCopied(false)}
        message="コピーされました"
      >
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
          "コピーされました"
        </Alert>
      </Snackbar>
    </>
  );
};

export default PaymentLinkTable;
